import { useCallback, useState } from 'react'

const KEY = 'nh_admin_theme'
export type Theme = 'dark' | 'light'

export function getTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'
  } catch {
    return 'dark'
  }
}

export function applyTheme(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t)
}

export function setTheme(t: Theme): void {
  try {
    localStorage.setItem(KEY, t)
  } catch {
    /* storage blocked — theme still applies for this session */
  }
  applyTheme(t)
}

/** Reactive theme with a setter (the rail's «Тёмная / Светлая»); `applyTheme(getTheme())` runs
 *  once at startup, and public/admin-theme.js sets it before the first paint. */
export function useTheme(): [Theme, (t: Theme) => void] {
  // What is on the page right now (public/admin-theme.js set it from the same key before the
  // first paint; a Storybook theme switch sets only the attribute).
  const [theme, set] = useState<Theme>(() =>
    typeof document !== 'undefined' && document.documentElement?.getAttribute('data-theme') === 'light' ? 'light' : getTheme(),
  )
  const choose = useCallback((next: Theme) => {
    setTheme(next)
    set(next)
  }, [])
  return [theme, choose]
}
